module.exports = __webpack_public_path__ + "img/O7.d7035b6b.png";